import React from 'react';
import regionBanner from '../src/imgs/regional_images/peten/region_peten_head.jpg';

export const RegionalBannerPeten = () => {
  return (

    <div className="regional-head-area container-fluid" style={{ backgroundImage: `url(${regionBanner})` }}>

        <div className="regional-title">
          <div className="regional-block-title"></div>
          <h3>Delegación regional de INAP<br></br>Petén</h3>
        </div>

    </div>
  )
}
